import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import { Provider } from 'react-redux';
// import * as Klaro from "klaro/dist/klaro";



const klaroCfg = {
    version: 1,
    elementID: 'klaro-cnt',
    // styling: {
    //     theme: ['light', 'top', 'wide'],
    // },
    noAutoLoad: false,
    htmlTexts: true,
    embedded: false,
    groupByPurpose: false,
    storageMethod: 'cookie',
    cookieName: 'klaro',
    cookieExpiresAfterDays: 365,
    default: false,
    mustConsent: false,
    acceptAll: true,
    hideDeclineAll: false,
    hideLearnMore: false,
    noticeAsModal: false,
    translations: {
        zz: {
            privacyPolicyUrl: '/privacy-cookies',
        },
		it: {
            // privacyPolicyUrl: '/#privacy',
			acceptAll: "Accetta tutto",
			acceptSelected: "Salva e continua",
			close: "Chiudi",
			consentModal: {
				description: `Questo pannello ti permette di esprimere alcune preferenze relative al trattamento delle tue informazioni personali.<br>
					Per rifiutare il tuo consenso alle attività di trattamento descritte di seguito, disattiva i singoli comandi o utilizza il pulsante “Rifiuta tutto” e conferma di voler salvare le scelte effettuate.`,
				privacyPolicy: {
					name: "informativa sulla privacy",
					text: "Per saperne di più, legga la nostra {privacyPolicy}."
				},
				title: "Le tue preferenze relative alla privacy",
			},
			consentNotice: {
				changeDescription: "Ci sono stati dei cambiamenti rispetto alla sua ultima visita, la preghiamo di rinnovare il suo consenso.",
				description: `Questo sito NON utilizza alcun cookie di profilazione.<br/>
				Sono invece utilizzati cookie di terze parti di tipo {purposes}. Se vuoi saperne di più sull’utilizzo dei cookie nel sito e leggere come disabilitarne l’uso, clicca su "Scopri di più e personalizza...".`,
				imprint: {
					name: "impronta"
				},
				learnMore: "Scopri di più e personalizza",
				privacyPolicy: {
					name: "informativa sulla privacy"
				},
				testing: "Modalità di test!",
				hideDeclineAll: true,
			},
			contextualConsent: {
				acceptAlways: "Sempre",
				acceptOnce: "Sì",
				description: "Vuole caricare contenuti esterni forniti da {title}?"
			},
			decline: "Rifiuta tutto",
			ok: "Accetta tutto",
			poweredBy: "Realizzato con Klaro!",
			privacyPolicy: {
				name: "Cookie policy",
				text: "{privacyPolicy}"
			},
			purposeItem: {
				service: "servizio",
				services: "servizi"
			},
			purposes: {
				advertising: {
					description: "Questi servizi elaborano le informazioni personali per mostrarle annunci pubblicitari personalizzati o basati su interessi.\n",
					title: "Pubblicità"
				},
				functional: {
					description: "Questi servizi sono essenziali per il corretto funzionamento di questo sito web. Non può disattivarli qui perché altrimenti il servizio non funzionerebbe correttamente.\n",
					title: "Fornitura di servizi"
				},
				marketing: {
					description: "Questi servizi elaborano le informazioni personali per mostrarle contenuti rilevanti su prodotti, servizi o argomenti che potrebbero interessarla.\n",
					title: "Marketing"
				},
				performance: {
					description: "Questi servizi elaborano le informazioni personali per ottimizzare il servizio offerto da questo sito web.\n",
					title: "Ottimizzazione delle prestazioni"
				}
			},
			save: "Salva",
			service: {
				disableAll: {
					description: "Utilizzi questo interruttore per attivare o disattivare tutti i servizi.",
					title: "Attivare o disattivare tutti i servizi"
				},
				optOut: {
					description: "Questo servizio è caricato di default (ma è possibile scegliere di non usufruirne)",
					title: "(opt-out)"
				},
				purpose: "Finalità",
				purposes: "Finalità",
				required: {
					description: "Questo servizio è sempre richiesto",
					title: "(sempre richiesto)"
				}
			},

			// Descrizione servizi
            // hubspot: { description: 'Servizio di chat' },
            // zendesk: { description: 'Servizio di chat' },
		},
    },
    services: [
		{
		  name: 'technical',
		  title: 'Cookie tecnici',
		  purposes: ['functional'],
		  cookies: [
			'__RequestVerificationToken',
			'ASP.NET_SessionId',
		  ],
		  default: true,
		  required: true,
		},
        {
            name: 'ga',
			title: 'Google Analytics',
            purposes: ['analytics'],
            cookies: [
                /^_ga(_.*)?/,
                '_clsk',
                '_clck',
                '_gid'
            ],
            callback: function(consent, service) {
                console.log(
                    'User consent for service ' + service.name + ': consent=' + consent
                );
            },
            required: false,
        },
    ],
};



ReactDOM.render(
    <React.StrictMode>
        <Provider store = {store}>
			<div id="klaro-cnt"></div>
            <App/>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// window.klaro = Klaro;
// window.klaroConfig = klaroCfg;

// Klaro.setup();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
